import { r as v, n as p, m as f, i, a as g, e as d, t as h, S as $ } from "./__packages__deps__web-929faed1.js";
const k = /* @__PURE__ */ h('<div class="tw-relative tw-h-full"><button class="tw-flex tw-h-full tw-items-center tw-justify-center tw-px-5"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="tw-h-4 tw-w-4"><path stroke-linecap="round" stroke-linejoin="round" d="M7.217 10.907a2.25 2.25 0 100 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186l9.566-5.314m-9.566 7.5l9.566 5.314m0 0a2.25 2.25 0 103.935 2.186 2.25 2.25 0 00-3.935-2.186zm0-12.814a2.25 2.25 0 103.933-2.185 2.25 2.25 0 00-3.933 2.185z"></path></svg></button></div>'), x = /* @__PURE__ */ h('<p class="tw-absolute tw-right-0 tw-bottom-[40px] tw-w-[200px] tw-px-4 tw-py-2 tw-text-center"></p>'), b = () => {
  const [r, s] = f(!1), m = () => {
    s(!0), navigator.clipboard.writeText(document.URL), setTimeout(() => {
      s(!1);
    }, 1e3);
  };
  return (() => {
    const n = k.cloneNode(!0), o = n.firstChild;
    return i(n, g($, {
      keyed: !0,
      get when() {
        return r();
      },
      children: () => (() => {
        const e = x.cloneNode(!0);
        return i(e, () => {
          var t;
          return (t = window == null ? void 0 : window.shareButton) == null ? void 0 : t.text;
        }), d((t) => {
          var c, w;
          const a = (c = window == null ? void 0 : window.shareButton) == null ? void 0 : c.background, l = (w = window == null ? void 0 : window.shareButton) == null ? void 0 : w.color;
          return a !== t._v$ && e.style.setProperty("background", t._v$ = a), l !== t._v$2 && e.style.setProperty("color", t._v$2 = l), t;
        }, {
          _v$: void 0,
          _v$2: void 0
        }), e;
      })()
    }), o), o.$$click = () => m(), d(() => o.disabled = r()), n;
  })();
}, u = document.getElementById("share-button");
u && v(b, u);
p(["click"]);
